const getDraftOrder = async (draftOrderId, customerId, customerEmail) => {
  const requestObj = {
    country,
    customer_id: customerId,
    customer_email: customerEmail,
    draft_order_id: draftOrderId,
  };
  const response = await fetch(
    `${backofficeApiUrl}/get-draft-order`,
    { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestObj),
    }
  );
  const draftOrder = await response.json();
  return draftOrder;
};

const reactivateExpiredDraftOrder = async (draftOrderId, customerId, customerEmail) => {
    const requestObj = {
        country,
        customer_id: customerId,
        customer_email: customerEmail,
        draft_order_id: draftOrderId,
    };
    const response = await fetch(
        `${backofficeApiUrl}/reactivate-mb-account`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestObj),
        }
    )
    return { response: response.status };
};
